import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  Input,
  Label,
  FormGroup,
} from "reactstrap";
import {
  updateMenu,
  updateMenuChild,
  updateMenuClaude,
} from "redux/actions/Screening/screeningActions";
import { connect } from "react-redux";
import _ from "lodash";
import { toast } from "react-toastify";
import {
  reportNameFromMenu,
  slugify,
  buildReportUrl,
  buildSeed,
  publishReportSeed,
  unpublishReportSeed,
  REPORTS_ROOT,
} from "services/lakeReport";


const EditarMenu = (props) => {
  // ** Const
  // ** Props
  const { open, setOpen } = props;
  const [menu, setMenu] = useState({
    menu: "",
  });
  const [menuOld, setMenuOld] = useState();
  const [menus, setMenus] = useState([]);
  const [maxSize, setMaxSize] = useState(0);
  // Config "Claude Connected" do report (persistida no banco, colunas claude_*).
  const [lake, setLake] = useState({
    connected: false,
    repo: "",
    branch: "main",
    tag: "",
    name: "",
  });
  const [lakeWasPublished, setLakeWasPublished] = useState(false);
  const [lakeOrigName, setLakeOrigName] = useState("");

  // Carrega o estado a partir do objeto do menu (vem do getMenu / banco).
  const initLakeFor = (menuItem) => {
    const defName = slugify(reportNameFromMenu(menuItem?.menu));
    const connected = !!menuItem?.claude_connected;
    const name = menuItem?.claude_name || defName;
    setLake({
      connected,
      repo: menuItem?.repo || "",
      branch: menuItem?.branch || "main",
      tag: menuItem?.tag || "",
      name,
    });
    setLakeWasPublished(connected);
    setLakeOrigName(name);
  };

  // Grava/remove o report.json no Lake (o que o MCP lê) conforme o checkbox.
  const handleLakeSeed = async (area) => {
    const reportName = reportNameFromMenu(menu.menu);
    const slug = lake.name || slugify(reportName);
    if (lake.connected) {
      if (!lake.repo) throw new Error("Informe o repositório git para conectar.");
      const url = buildReportUrl(area, menu.menu, menu.id);
      const seed = buildSeed({
        name: reportName,
        aliases: lake.tag,
        url,
        repoUrl: lake.repo,
        branch: lake.branch,
      });
      await publishReportSeed({ area, slug, seed });
      // se o nome/pasta mudou, remove o antigo para não duplicar
      if (lakeWasPublished && lakeOrigName && lakeOrigName !== slug) {
        await unpublishReportSeed({ area, slug: lakeOrigName });
      }
      toast.success("Report conectado ao Claude.");
    } else if (lakeWasPublished) {
      await unpublishReportSeed({ area, slug: lakeOrigName || slug });
      toast.success("Report desconectado do Claude.");
    }
  };

  // Persiste a config no banco (colunas claude_*), chaveado pelo id do menu.
  const handleClaudePersist = () => {
    const slug = lake.name || slugify(reportNameFromMenu(menu.menu));
    props.updateMenuClaude({
      params: {
        arg1: menu.id,
        arg2: lake.connected ? 1 : 0,
        arg3: lake.connected ? lake.repo : "",
        arg4: lake.connected ? lake.branch : "",
        arg5: lake.connected ? lake.tag : "",
        arg6: lake.connected ? slug : "",
      },
    });
  };

  useEffect(() => {
    if (open) {
      let menus = JSON.parse(localStorage.getItem("menus"));
      let menuSelecionado = menus?.find(
        (item) =>
          // eslint-disable-next-line eqeqeq
          item.area == localStorage.getItem("area") &&
          // eslint-disable-next-line eqeqeq
          item.id == localStorage.getItem("idMenu")
      );
      if (menuSelecionado) {
        setMenu({
          id: menuSelecionado.id,
          menu: menuSelecionado.menu,
          emails: menuSelecionado.usuarios,
          grupos: menuSelecionado.grupos,
          confidencial: menuSelecionado.confidencialAbs,
          principal: menuSelecionado.principal,
          ordem: menuSelecionado.ordem,
          habilita_arquivo_local: menuSelecionado.habilita_arquivo_local,
          diretorio_local: menuSelecionado.diretorio_local
            ? menuSelecionado.diretorio_local
            : "P:\\sistemas\\reports",
        });
        //setOrdem(menuSelecionado.ordem);
        setMenuOld(menuSelecionado.menu);
        setMaxSize(props.getListMenus(menuSelecionado).length);
        initLakeFor(menuSelecionado);
      } else setMenuOld("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  useEffect(() => {
    if (props.editMenu) window.location.reload();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.editMenu]);

  useEffect(() => {
    //setMenu({ nome: localStorage.getItem("menu_completo")?.replace(/\//g,"|") });
    const menus = _.sortBy(
      JSON.parse(localStorage.getItem("menus"))?.filter(
        (item) => item.area === localStorage.getItem("area")
      ),
      (item) => item.menu
    );
    menus.unshift({ menu: "" });
    setMenus(menus);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localStorage.getItem("menus")]);

  const editChilds = (area) => {
    let menusChilds = menus.filter(
      (item) =>
        item.menu?.replace(/\s/g, '').startsWith(menuOld.replace(/\s/g, '') + "|") &&
        item.menu !== menuOld
    );
    for (let item of menusChilds) {
      let model = {
        params: {
          arg1: area,
          arg2: item.menu,
          arg3: item.menu.replace(menuOld, menu.menu),
          arg4: item.usuarios,
          arg5: item.grupos || "",
          arg6: item.confidencialAbs || false,
          arg7: item.principal || false,
          arg8: item.ordem || 1,
          arg9: item.habilita_arquivo_local
            ? item.habilita_arquivo_local
            : false,
          arg10: item.diretorio_local
            ? item.diretorio_local
            : "P:\\sistemas\\reports",
        },
      };
      props.updateMenuChild(model);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let area = localStorage.getItem("area");
    // Claude Connected: grava o report.json no Lake e persiste no banco.
    // Só persiste no banco se o Lake deu certo (evita divergência banco x Lake).
    try {
      await handleLakeSeed(area);
      handleClaudePersist();
    } catch (err) {
      toast.error("Claude: " + (err?.message || "falha ao conectar"));
    }
    if (menuOld !== menu.menu) editChilds(area);
      let model = {
        params: {
          arg1: area,
          arg2: menuOld,
          arg3: menu.menu,
          arg4: menu.emails,
          arg5: menu.grupos || "",
          arg6: menu.confidencial || false,
          arg7: menu.principal || false,
          arg8: menu.ordem || 1,
          arg9: menu.habilita_arquivo_local
            ? menu.habilita_arquivo_local
            : false,
          arg10: menu.diretorio_local
            ? menu.diretorio_local
            : "P:\\sistemas\\reports",
        },
      };
      props.updateMenu(model);
    // } else {
    //   const from = ordem;
    //   const to = menu.ordem;
    //   menu.ordem = ordem;
    //   menu.old = menuOld;
    //   menu.area = area;
    //   props.handleOrderMenu(menu, Number(from), Number(to));
    // }
    setOpen(false);
  };

  const handleSelectMenu = (item) => {
    setMenuOld(item.menu);
    //setOrdem(item.ordem);
    
    setMaxSize(props.getListMenus(item).length);
    setMenu({
      id: item.id,
      menu: item.menu,
      emails: item.usuarios,
      grupos: item.grupos,
      confidencial: item.confidencialAbs,
      principal: item.principal,
      ordem: item.ordem,
      habilita_arquivo_local: item.habilita_arquivo_local,
      diretorio_local: item.diretorio_local
        ? item.diretorio_local
        : "P:\\sistemas\\reports",
    });
    initLakeFor(item);
  };

  return (
    <Modal
      isOpen={open}
      toggle={() => setOpen(!open)}
      className={`modal-dialog-centered`}
      size="lg"
    >
      <ModalHeader toggle={() => setOpen(!open)}>Editar Menu </ModalHeader>
      <ModalBody>
        <Form id="form" className="mb-1">
          <FormGroup>
            <Label>Selecione o Menu</Label>
            <Input
              defaultValue="option1"
              id="exampleRadios11"
              name="exampleRadioz"
              type="select"
              value={JSON.stringify(
                menus.find((item) => item.menu === menuOld)
              )}
              onChange={(event) =>
                handleSelectMenu(JSON.parse(event.target.value))
              }
            >
              {menus.map((item) => (
                <option
                  value={JSON.stringify(item)}
                  onClick={() => handleSelectMenu(item)}
                >
                  {item.menu}
                </option>
              ))}
            </Input>
          </FormGroup>
          <FormGroup>
            <Label for="menu">menu</Label>
            <Input
              type="text"
              id="name"
              placeholder="Menu"
              value={menu.menu}
              name="menu"
              onChange={(e) =>
                setMenu({
                  ...menu,
                  [e.target.name]: e.target.value,
                })
              }
            />
          </FormGroup>
          <FormGroup>
            <Label for="nome">
              Emails com acesso{" "}
              <span style={{ fontSize: 11 }}>*(separados por vírgula)</span>
            </Label>
            <Input
              type="textarea"
              id="name"
              placeholder="Emails com acesso"
              value={menu.emails}
              name="name"
              onChange={(e) =>
                setMenu({
                  ...menu,
                  emails: e.target.value,
                })
              }
            />
          </FormGroup>
          <FormGroup>
            <Label for="nome">
              Grupos com acesso{" "}
              <span style={{ fontSize: 11 }}>*(separados por vírgula)</span>
            </Label>
            <Input
              type="text"
              id="name"
              placeholder="Grupos com acesso"
              value={menu.grupos}
              name="name"
              onChange={(e) =>
                setMenu({
                  ...menu,
                  grupos: e.target.value,
                })
              }
            />
          </FormGroup>
          <FormGroup className="ml-4 mt-3">
            <Label>
              <Input
                type="checkbox"
                checked={menu.confidencial}
                onChange={(e) =>
                  setMenu({
                    ...menu,
                    confidencial: !menu.confidencial,
                  })
                }
              />
              Intranet{" "}
              <span style={{ fontSize: 11 }}>
                *(acesso somente pelo escritorio)
              </span>{" "}
            </Label>
          </FormGroup>
          <FormGroup className="ml-4 mt-3">
            <Label>
              <Input
                type="checkbox"
                checked={menu.habilita_arquivo_local}
                onChange={(e) =>
                  setMenu({
                    ...menu,
                    habilita_arquivo_local: !menu.habilita_arquivo_local,
                  })
                }
              />
              Salvar em pasta local{" "}
            </Label>
          </FormGroup>
          {menu.habilita_arquivo_local ? (
            <FormGroup>
              <Label for="nome">
                Diretório raiz
                <span style={{ fontSize: 11 }}>
                  *(Diretório raiz onde será salvo os arquivos das abas desse
                  menu)
                </span>
              </Label>
              <Input
                type="text"
                id="name"
                placeholder="Diretório raiz"
                value={menu.diretorio_local}
                name="name"
                onChange={(e) =>
                  setMenu({
                    ...menu,
                    diretorio_local: e.target.value,
                  })
                }
              />
            </FormGroup>
          ) : null}
          <FormGroup className="ml-4 mt-3">
            <Label>
              <Input
                type="checkbox"
                checked={menu.principal}
                onChange={(e) =>
                  setMenu({
                    ...menu,
                    principal: !menu.principal,
                  })
                }
              />
              Menu Principal{" "}
              <span style={{ fontSize: 11 }}>
                *(menu que aparecerá quando escolher a area{" "}
                {localStorage.getItem("area")})
              </span>{" "}
            </Label>
          </FormGroup>
          <FormGroup className="ml-4 mt-3">
            <Label>
              <Input
                type="checkbox"
                checked={lake.connected}
                onChange={() =>
                  setLake({ ...lake, connected: !lake.connected })
                }
              />
              Conectar no Claude{" "}
              <span style={{ fontSize: 11 }}>
                *(conecta este report ao Claude — a IA passa a enxergar e
                responder sobre ele)
              </span>
            </Label>
          </FormGroup>
          {lake.connected ? (
            <div className="pl-4">
              <FormGroup>
                <Label for="claudeRepo">
                  Repositório git <span style={{ color: "red" }}>*</span>
                </Label>
                <Input
                  type="text"
                  id="claudeRepo"
                  placeholder="https://dev.azure.com/absolutedevops/services/_git/<repo>"
                  value={lake.repo}
                  onChange={(e) => setLake({ ...lake, repo: e.target.value })}
                />
              </FormGroup>
              <FormGroup>
                <Label for="claudeBranch">Branch</Label>
                <Input
                  type="text"
                  id="claudeBranch"
                  placeholder="main"
                  value={lake.branch}
                  onChange={(e) => setLake({ ...lake, branch: e.target.value })}
                />
              </FormGroup>
              <FormGroup>
                <Label for="claudeTag">
                  Tag{" "}
                  <span style={{ fontSize: 11 }}>
                    *(opcional, separadas por vírgula — palavras-chave para a IA
                    localizar o report)
                  </span>
                </Label>
                <Input
                  type="text"
                  id="claudeTag"
                  placeholder="ex.: dashboard de opcoes de fx, fx pricing"
                  value={lake.tag}
                  onChange={(e) => setLake({ ...lake, tag: e.target.value })}
                />
              </FormGroup>
              <FormGroup>
                <Label for="claudeName">
                  Nome da pasta (DataLakeLLM){" "}
                  <span style={{ fontSize: 11 }}>
                    *({REPORTS_ROOT}/{slugify(localStorage.getItem("area"))}/&lt;nome&gt;)
                  </span>
                </Label>
                <Input
                  type="text"
                  id="claudeName"
                  value={lake.name}
                  onChange={(e) => setLake({ ...lake, name: e.target.value })}
                />
              </FormGroup>
            </div>
          ) : null}
          <FormGroup>
            <Label for="ordem">Ordem</Label>
            <Input
              type="number"
              min={1}
              id="ordem"
              placeholder="Ordenação no Menu"
              value={menu.ordem}
              name="ordem"
              onChange={(e) => {
                const value =
                  e.target.value < 1 || e.target.value > maxSize
                    ? menu.ordem
                    : e.target.value;
                setMenu({
                  ...menu,
                  [e.target.name]: value,
                });
              }}
            />
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button type="submit" onClick={(e) => handleSubmit(e)} color="primary">
          Editar
        </Button>
      </ModalFooter>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  return {
    publish: state.screening.screening.publish,
    menuNew: state.screening.screening.menuNew,
    editMenu: state.screening.screening.editMenu,
    //e/rror: state.screening.screening.error,
    //loading: state.screening.screening.loading,
  };
};

export default connect(mapStateToProps, {
  updateMenu,
  updateMenuChild,
  updateMenuClaude,
})(EditarMenu);
